export const AIRCRAFT_COUNTABLE_FUEL_GAL = 'FUEL_GAL';
export const AIRCRAFT_COUNTABLE_FUEL_KG = 'FUEL_KG';
export const AIRCRAFT_COUNTABLE_FUEL_LB = 'FUEL_LB';
export const AIRCRAFT_COUNTABLE_FUEL_LITERS = 'FUEL_LITERS';
export const AIRCRAFT_FUEL_COUNTABLES = [
    AIRCRAFT_COUNTABLE_FUEL_LB,
    AIRCRAFT_COUNTABLE_FUEL_KG,
    AIRCRAFT_COUNTABLE_FUEL_GAL,
    AIRCRAFT_COUNTABLE_FUEL_LITERS,
];
export function countableTypeIsFuel(ct) {
    return AIRCRAFT_FUEL_COUNTABLES.includes(ct);
}
const toLitersMatrix = {
    [AIRCRAFT_COUNTABLE_FUEL_GAL]: 3.785,
    [AIRCRAFT_COUNTABLE_FUEL_LITERS]: 1,
    [AIRCRAFT_COUNTABLE_FUEL_LB]: 0.565,
    [AIRCRAFT_COUNTABLE_FUEL_KG]: 1.2455,
};
export function convertFuelToLiters(sourceAmount, sourceType) {
    return sourceAmount * toLitersMatrix[sourceType];
}
export function convertFuelToAircraftUnits(liters, sourceType) {
    return liters / toLitersMatrix[sourceType];
}
//# sourceMappingURL=countableFuel.js.map